import { type JSX } from "react";
import type { OfferData, TemplateType } from "@/components/offer/offerDocumentTypes";
import { OFFER_TEMPLATE_CONFIGS } from "@/components/offer/templateConfigs";

export type OfferDocumentRendererProps = {
  offerData: OfferData;
  templateType: TemplateType;
  templateStyle: string;
};

export function OfferDocumentRenderer({
  offerData,
  templateType,
  templateStyle,
}: OfferDocumentRendererProps): JSX.Element {
  const config = OFFER_TEMPLATE_CONFIGS[templateType] ?? OFFER_TEMPLATE_CONFIGS.quick;

  return (
    <>
      {config.map((section) => {
        if (section.isVisible && !section.isVisible(offerData)) return null;
        const Section = section.component;
        return (
          <Section
            key={section.key}
            offerData={offerData}
            templateStyle={templateStyle}
            onExclusionsChange={offerData.onExclusionsChange}
          />
        );
      })}
    </>
  );
}

